// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"cc6fb4bc","453":"c66a5846","701":"135df13a"}[chunkId] + ".chunk.js";
};